import { render, staticRenderFns } from "./AppHowWellDoesItPreventPregnancy.vue?vue&type=template&id=5330a494&scoped=true&"
import script from "./AppHowWellDoesItPreventPregnancy.vue?vue&type=script&lang=js&"
export * from "./AppHowWellDoesItPreventPregnancy.vue?vue&type=script&lang=js&"
import style0 from "./AppHowWellDoesItPreventPregnancy.vue?vue&type=style&index=0&id=5330a494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5330a494",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
